var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
          "before-reset-search": _vm.beforeResetSearch,
          "default-sort": _vm.defaultSort,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
          "sort-change": _vm.sortChange,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseOrderDetail.table.skuName"
                          ),
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.skuName,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "skuName", $$v)
                            },
                            expression: "queryParams.skuName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c("BjFormItemCode", {
                      attrs: {
                        label: _vm.$t(
                          "BusinessPurchaseOrderDetail.table.skuCode"
                        ),
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleQuery.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.queryParams.skuCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryParams, "skuCode", $$v)
                        },
                        expression: "queryParams.skuCode",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("BusinessPurchaseForecast.level"),
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "show-disabled": true,
                            "option-list": _vm.SALES_GRADE_LIST,
                            multiple: "",
                            "collapse-tags": true,
                          },
                          on: { change: _vm.selectSalesMonths },
                          model: {
                            value: _vm.queryParams.salesMonthsLevels,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "salesMonthsLevels",
                                $$v
                              )
                            },
                            expression: "queryParams.salesMonthsLevels",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "beforeSearchBtn",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: 24 - _vm.colSpan } },
                  [
                    _c("BjStatusTabs", {
                      attrs: {
                        value: _vm.auditTabsValue,
                        "option-list": _vm.TAB_LIST,
                      },
                      on: { handleTabClick: _vm.handleTabClick },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _c("BjFrontendExport", {
                      attrs: {
                        type: "primary",
                        "label-list": _vm.exportLabelList,
                        rows: _vm.selectedRows,
                        "file-name": _vm.inventoryExportFileName,
                        "auto-format-date": false,
                      },
                      on: { "export-success": _vm.resetAfterExport },
                    }),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            _vm.visibleTooltip = true
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("BusinessPurchaseForecast.userManual"))
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop === "skuCode"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: "skuCode",
                            title: _vm.$t(
                              "BusinessPurchaseOrderDetail.table.skuCode"
                            ),
                            sortable: "",
                            width: "150px",
                          },
                        })
                      : col.prop === "skuAvgDaySales"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: "skuAvgDaySales",
                            title: _vm.$t(
                              "BusinessPurchaseForecast.skuAvgDaySales"
                            ),
                            sortable: "",
                            width: "108px",
                          },
                        })
                      : col.prop === "salesMonths"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: "salesMonths",
                            title: _vm.$t("BusinessPurchaseForecast.month"),
                            sortable: "",
                            width: "120px",
                          },
                        })
                      : col.prop === "salesMonthsLevel"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: "salesMonthsLevel",
                            width: "100px",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _c(
                                      "p",
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "BusinessPurchaseForecast.level"
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c(
                                          "el-tooltip",
                                          { attrs: { placement: "top" } },
                                          [
                                            _c(
                                              "span",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content",
                                              },
                                              [
                                                _vm._v("1: 0-1 months"),
                                                _c("br"),
                                                _vm._v("2: 1-2 months"),
                                                _c("br"),
                                                _vm._v("3: 2-3 months"),
                                                _c("br"),
                                                _vm._v("4: 3-6 months"),
                                                _c("br"),
                                                _vm._v("5: 6-9 months"),
                                                _c("br"),
                                                _vm._v("6: 9-12 months"),
                                                _c("br"),
                                                _vm._v("7: 12 months or more"),
                                                _c("br"),
                                              ]
                                            ),
                                            _c("i", {
                                              staticClass: "el-icon-question",
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : col.prop === "breakevenPrice"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: "breakevenPrice",
                            width: "98px",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _c(
                                      "p",
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "BusinessPurchaseForecast.breakevenPrice"
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c(
                                          "el-tooltip",
                                          { attrs: { placement: "top" } },
                                          [
                                            _c(
                                              "span",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "BusinessPurchaseForecast.breakevenPriceTooltip"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c("i", {
                                              staticClass: "el-icon-question",
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : col.prop === "marginPrice"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: "marginPrice",
                            width: "150px",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _c(
                                      "p",
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "BusinessPurchaseForecast.marginPrice"
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c(
                                          "el-tooltip",
                                          { attrs: { placement: "top" } },
                                          [
                                            _c(
                                              "span",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "BusinessPurchaseForecast.marginPriceTooltip"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c("i", {
                                              staticClass: "el-icon-question",
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : col.prop === "deliveryTime"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: "deliveryTime",
                            width: "145px",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _c(
                                      "p",
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "BusinessPurchaseForecast.deliveryTime"
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c(
                                          "el-tooltip",
                                          { attrs: { placement: "top" } },
                                          [
                                            _c(
                                              "span",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "BusinessPurchaseForecast.deliveryTimeTooltip"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c("i", {
                                              staticClass: "el-icon-question",
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : col.prop === "operationSuggestions"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: "operationSuggestions",
                            width: "180px",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _c(
                                      "p",
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "BusinessPurchaseForecast.operationSuggestions"
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c(
                                          "el-tooltip",
                                          { attrs: { placement: "top" } },
                                          [
                                            _c(
                                              "span",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "BusinessPurchaseForecast.operationSuggestionsTooltip"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c("i", {
                                              staticClass: "el-icon-question",
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _c("div", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.setOperationSuggestions(
                                            row[col.prop]
                                          )
                                        ),
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : col.prop === "salesMonthsHistory"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: "salesMonthsHistory",
                            fixed: col.fixed || "right",
                            width: "200px",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _c(
                                      "p",
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "BusinessPurchaseForecast.salesMonthsHistory"
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c(
                                          "el-tooltip",
                                          { attrs: { placement: "top" } },
                                          [
                                            _c(
                                              "span",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "BusinessPurchaseForecast.salesMonthsHistoryText1"
                                                    )
                                                  ) +
                                                    ": " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "BusinessPurchaseForecast.salesMonthsHistoryTooltip2"
                                                      )
                                                    )
                                                ),
                                                _c("br"),
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "BusinessPurchaseForecast.salesMonthsHistoryText2"
                                                    )
                                                  ) +
                                                    ": " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "BusinessPurchaseForecast.salesMonthsHistoryTooltip1"
                                                      )
                                                    )
                                                ),
                                              ]
                                            ),
                                            _c("i", {
                                              staticClass: "el-icon-question",
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onMonth(row[col.prop])
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "BusinessPurchaseForecast.salesMonthsHistoryText1"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onGrade(row[col.prop])
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "BusinessPurchaseForecast.salesMonthsHistoryText2"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : col.prop === "shipmentQty"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: "shipmentQty",
                            title: _vm.$t(
                              "BusinessPurchaseForecast.shipmentQty"
                            ),
                            sortable: "",
                            width: "140px",
                          },
                        })
                      : col.prop === "onHandQty"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: "onHandQty",
                            title: _vm.$t("BusinessPurchaseForecast.onHandQty"),
                            sortable: "",
                            width: "115px",
                          },
                        })
                      : col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "actualProfitRate"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("profitMarginFilter")(
                                                  row[col.prop]
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                row[col.prop],
                                                row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "BjDialog",
        {
          attrs: {
            visible: _vm.visible,
            width: "1000px",
            "destroy-on-close": "",
          },
          on: {
            close: function ($event) {
              _vm.visible = false
            },
          },
        },
        [
          _vm.visible
            ? _c("LineChart", { attrs: { "chart-data": _vm.lineChartData } })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "BjDialog",
        {
          attrs: { visible: _vm.visibleTooltip },
          on: {
            close: function ($event) {
              _vm.visibleTooltip = false
            },
          },
        },
        [
          _c("div", { staticClass: "manual" }, [
            _c("p", { staticClass: "title" }, [
              _vm._v(
                "1：" +
                  _vm._s(_vm.$t("BusinessPurchaseForecast.userManualData.p1"))
              ),
            ]),
            _c("div", [
              _c("p", { staticClass: "title" }, [
                _vm._v(
                  "2：" +
                    _vm._s(_vm.$t("BusinessPurchaseForecast.userManualData.p2"))
                ),
              ]),
              _c("p", [
                _vm._v(
                  "2.1：" +
                    _vm._s(
                      _vm.$t("BusinessPurchaseForecast.userManualData.p21")
                    ) +
                    " "
                ),
              ]),
              _c("p", { staticClass: "formula" }, [
                _vm._v(
                  _vm._s(_vm.$t("BusinessPurchaseForecast.userManualData.p22"))
                ),
              ]),
              _c("p", { staticClass: "formula" }, [
                _vm._v(
                  _vm._s(_vm.$t("BusinessPurchaseForecast.userManualData.p23"))
                ),
              ]),
              _c("p", [
                _vm._v(
                  "2.2：" +
                    _vm._s(
                      _vm.$t("BusinessPurchaseForecast.userManualData.p24")
                    ) +
                    " "
                ),
              ]),
            ]),
            _c("p", { staticClass: "title" }, [
              _vm._v(
                "3：" +
                  _vm._s(_vm.$t("BusinessPurchaseForecast.userManualData.p3")) +
                  " "
              ),
            ]),
            _c("div", [
              _c("p", { staticClass: "title" }, [
                _vm._v(
                  "4：" +
                    _vm._s(
                      _vm.$t("BusinessPurchaseForecast.userManualData.p4")
                    ) +
                    " "
                ),
              ]),
              _c("p", [
                _vm._v(
                  "4.1: " +
                    _vm._s(
                      _vm.$t("BusinessPurchaseForecast.userManualData.p41")
                    )
                ),
              ]),
              _c("p", [
                _vm._v(
                  "4.2: " +
                    _vm._s(
                      _vm.$t("BusinessPurchaseForecast.userManualData.p42")
                    )
                ),
              ]),
              _c("p", [
                _vm._v(
                  "4.3: " +
                    _vm._s(
                      _vm.$t("BusinessPurchaseForecast.userManualData.p43")
                    )
                ),
              ]),
            ]),
            _c("div", [
              _c("p", { staticClass: "title" }, [
                _vm._v(
                  "5：" +
                    _vm._s(_vm.$t("BusinessPurchaseForecast.userManualData.p5"))
                ),
              ]),
              _c("p", [
                _vm._v(
                  "5.1：" +
                    _vm._s(
                      _vm.$t("BusinessPurchaseForecast.userManualData.p51")
                    )
                ),
              ]),
              _c("p", [
                _vm._v(
                  "5.2：" +
                    _vm._s(
                      _vm.$t("BusinessPurchaseForecast.userManualData.p52")
                    )
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }